import React, { useState }  from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import axios from 'axios';


import { useTranslation } from 'react-i18next';



const PricingSection = () => {

    const [show, setShow] = useState(false);
    const [showOK, setShowOK] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleCloseOK = () => setShowOK(false);
    const handleShowOK = () => setShowOK(true);


    const setBasic = () => {

        setFormPackage("Basic");
        setShow(true);
    }

    const setNormal = () => {
        
        setFormPackage("Normal");
        setShow(true);
    }

    const setMany = () => {
        
        setFormPackage("Many");
        setShow(true);
    }

    const setDevelopment = () => {
        
        setFormPackage("Development");
        setShow(true);
    }

    

    const [loading, setLoading] = useState(false);

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [subject, setSubject] = useState("");
    const [comments, setComments] = useState("");
    const [company, setCompany] = useState("");
    const [form_package, setFormPackage] = useState("");
    const [phone, setPhone] = useState("");



    const [sentMsg, setSentMsg] = useState("")

    const submitForm = async () => {
            
        setLoading(true);
       // handleShow();
        // With all properties
        const headers = {
            'Content-Type': 'application/json',
          }
        
        let body = {
        name: name,
        email: email,
        subject: subject,
        comments: comments,
        company: company,
        form_package: form_package,
        phone: phone
        };
        axios
        .post(" https://ogcauyaojf.execute-api.eu-central-1.amazonaws.com/prod/contact-us", JSON.stringify(body), {
            headers: headers
          })
        .then(function(response) {
            console.log(response.data);
            setSentMsg(t('sent_message.label'));
            handleShowOK();
            setLoading(false);
            handleClose();
            
            
        })
        .catch(function(error) {
            console.log(error);
            setSentMsg(t('error_msg.label'));
            handleShowOK();
            setLoading(false);
        });
    }


    const { t, i18n } = useTranslation();

    const clickedPrice = (event) => {
        console.log('The link was clicked. Finish');
        window.scrollTo(0,document.body.scrollHeight );
        
    }

    const  PlaneList = [{
                "id": 1,
                "name": "Basic",
                "users": "1-5",
                "price": "5,9€",
                "function": setBasic,
                "button" : t('buy.label'),
                "is_active" : false
            },
            {
                "id": 2,
                "name": "Normal",
                "users": "1-5",
                "price": "6,9€",
                "function": setNormal,
                "button" : t('buy.label'),
                "is_active" : true
            },{
                "id": 3,
                "name": "> 5 " + t('users.label'),
                "users" : " 6-10 users",
                "price": t('offer_title.label'),
                "function": setMany,
                "button" : t('offer_title.label'),
                "is_active" : false
            },
            ,{
                "id": 4,
                "name": t('tailored.label'),
                "users" : " > 10",
                "price": t('offer_title.label'),
                "fees": "No",
                "function": setDevelopment,
                "button" : t('contact.label'),
                "is_active" : false
            },
            ];
        

 
        return (
            <React.Fragment>
                <section className="section " id="pricing">
                    <div className="container ">
                        <Row>
                            <Col lg="12">
                                <div className="title-heading mb-5">
                                    <h3 className="text-dark mb-1 font-weight-light text-uppercase">{t('pricing.label')}</h3>
                                    <div className="title-border-simple position-relative"></div>
                                </div>
                            </Col>
                        </Row>
                        <div className=" row ">

                        {PlaneList.map((plan, index) => {
                                return  <Col  lg="3" md="6" key={index}>
                                            <div className={plan.is_active ? "pricing-box active mt-2" : "pricing-box mt-2"}>
                                                <div className="price bg-light position-relative p-2">
                                                    <div className="float-left">
                                                        <h5 className="text-dark title mt-2 font-weight-normal f-18 mb-0">{plan.name}</h5>
                                                    </div>
                                                    <div className="">
                                                        <h2 className="text-dark font-weight-normal text-right mb-0">{plan.price}</h2>
                                                    </div>
                                                </div>
                                                <div className="p-2 pricing-list">
                                                {plan.id == 1 && 
                                                    <ul className="list-unstyled mb-0">
                                                        <li className="text-muted f-14">{t('price_per_person.label')}</li>
                                                        <li className="text-muted f-14">{t('free_period.label')}</li>
                                                        <li className="text-muted f-14">{t('receipts_documents.label')}</li>
                                                        <li className="text-muted f-14">{t('support_person.label')}</li>
                                                        <li className="text-muted f-14">{t('invoicing_period.label')}</li>
                                                        <li className="text-muted f-14">{t('vat_label.label')}</li>
                                                       
                                                    
                                                    </ul>
                                                }
                                                {plan.id == 2 && 
                                                    <ul className="list-unstyled mb-0">
                                                       <li className="text-muted f-14">{t('price_per_person.label')}</li>
                                                        <li className="text-muted f-14">{t('free_period.label')}</li>
                                                        <li className="text-muted f-14">{t('receipts_documents.label')}, <b>{t('travel_invoices_low.label')}</b></li>
                                                        <li className="text-muted f-14">{t('support_person.label')}</li>
                                                        <li className="text-muted f-14">{t('invoicing_period.label')}</li>
                                                        <li className="text-muted f-14">{t('vat_label.label')}</li>
                                                       
                                                    
                                                    </ul>
                                                }
                                                {plan.id == 3 && 
                                                    <ul className="list-unstyled mb-0">
                                                        <li className="text-muted f-14">{t('offer.label')}</li>
                                                        <li className="text-muted f-14">{t('free_period.label')}</li>
                                                        <li className="text-muted f-14">{t('receipts_documents.label')}, {t('travel_invoices_low.label')}</li>
                                                        <li className="text-muted f-14">{t('support_person.label')}</li>
                                                        <li className="text-muted f-14">{t('invoicing_period.label')}</li>
                                                        <li className="text-muted f-14">{t('vat_label.label')}</li>
                                                       
                                                    
                                                    </ul>
                                                }
                                                {plan.id == 4 && 
                                                    <ul className="list-unstyled mb-0">
                                                      <li className="text-muted f-14">{t('develoment.label')}</li>
                                                        <li className="text-muted f-14"> <br/> </li>
                                                        <li className="text-muted f-14"> <br/> </li>
                                                        <li className="text-muted f-14"> <br/> </li>
                                                        <li className="text-muted f-14"> {t('invoicing_scheme.label')}     </li>
                                                        <li className="text-muted f-14">{t('contact_us.label')}</li>
                                                    
                                                    
                                                    </ul>
                                                }

                                                </div>
                                                <div className="pl-2 mb-2 mt-2">
                                                <Link to="#contact" onClick={plan.function} className={plan.is_active ? "btn btn-outline btn-sm active" : "btn btn-outline btn-sm"} >{plan.button}</Link>
                                                </div>
                                            </div>
                                        </Col>
                            })}
                        </div>
                    </div>
                    
               
                </section>

                <Modal 
                
                    show={show} 
                    onHide={handleClose} 
                    dialogClassName="modal-80w">

                    <Modal.Header closeButton>
                    <Modal.Title>{t('contact.label')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body >
                    <div className="contact-box p-5">
                                    <Row>
                                        <Col lg="8" md="6">
                                            <div className="custom-form p-3">
                                                <div id="message"></div>
                                                <AvForm id="contact-form" >
                                                    <Row>
                                                        
                                                        <Col lg="6">
                                                            
                                                            <div className="form-group app-label">
                                                                <AvField name="name" type="text" onChange={e => setName(e.target.value)} errorMessage={t('error_field.label')} validate={{ required: { value: true } }}  placeholder={t('name.label')} />
                                                            </div>
                                                        </Col>
                                                        <Col lg="6">
                                                            
                                                            <div className="form-group app-label">
                                                                <AvField name="company" type="text" onChange={e => setCompany(e.target.value)} errorMessage={t('error_field.label')} validate={{ required: { value: true } }}  placeholder={t('company.label')} />
                                                            </div>
                                                        </Col>
                                                        <Col lg="6">
                                                            <div className="form-group app-label">
                                                                <AvField name="phone" type="text" onChange={e => setPhone(e.target.value)} errorMessage={t('error_field.label')} validate={{ required: { value: false } }}  placeholder={t('phone.label')} />
                                                            </div>
                                                        </Col>
                                                        <Col lg="6">
                                                            <div className="form-group app-label">
                                                                <AvField name="email" type="text" onChange={e => setEmail(e.target.value)} errorMessage={t('error_email.label')} validate={{ required: { value: true }, email: { value: true } }} placeholder={t('email.label')} />
                                                            </div>
                                                        </Col>
                                                        <Col lg="12">
                                                            <div className="form-group app-label">
                                                                <AvField name="subject" type="text" onChange={e => setSubject(e.target.value)} errorMessage={t('error_field.label')} validate={{ required: { value: true } }} placeholder={t('subject.label')} />
                                                            </div>
                                                        </Col>
                                                        <Col lg="12">
                                                            <div className="form-group app-label">
                                                                <AvField name="comments" type="textarea" onChange={e => setComments(e.target.value)} errorMessage={t('error_field.label')} validate={{ required: { value: true } }} rows="5"  placeholder={t('message.label')} />
                                                            </div>
                                                        </Col>
                                                        <Row>
                                                            <Col sm="12">
                                                              &nbsp; &nbsp;  <button variant="primary" type="submit" onClick={submitForm} disabled={!email || !name || !subject || !comments} className=" btn btn-custom" >
                                                              
                                                              {loading && (
                                                                        <i
                                                                        className="fa fa-refresh fa-spin"
                                                                        style={{ marginRight: "5px" }}
                                                                        />
                                                                    )}
                                                                    {loading && <span>{t('sending.label')}...</span>}
                                                                    {!loading && <span>{t('send_message.label')}</span>}
                                                                  
                                                                  </button>
                                                             
                                                                <div id="simple-msg"></div>
                                                            </Col>
                                                        </Row>

                                                    </Row>
                                                </AvForm>
                                            </div>
                                        </Col>

                                        <div className="col-lg-4 col-md-6">
                                            <div className="contact-cantent p-3">
                                               

                                                <div className="contact-details mt-2">
                                                    <div className="float-left contact-icon mr-3 mt-2">
                                                        <i className="mdi mdi-email-outline text-muted h5"></i>
                                                    </div>
                                                    <div className="app-contact-desc text-muted pt-1">
                                                        <p className="mb-0 info-title f-13">{t('email.label')} :</p>
                                                        <p className="mb-0 f-13"><Link to="" className="text-muted">info@jrinvoice.fi</Link></p>
                                                    </div>
                                                </div>

                                                <div className="contact-details mt-2">
                                                    <div className="float-left contact-icon mr-3 mt-2">
                                                        <i className="mdi mdi-map-marker text-muted h5"></i>
                                                    </div>
                                                    <div className="app-contact-desc text-muted pt-1">
                                                        <p className="mb-0 info-title f-13">Location :</p>
                                                        <p className="mb-0 f-13"><Link to="" className="text-muted">JABB Oy Ab, Vaasa, Finland<br/>2497134-6</Link></p>
                                                    </div>
                                                </div>

                                                
                                            </div>
                                        </div>
                                    </Row>
                                </div>
                              


                    </Modal.Body>
                    <Modal.Footer>
                    
                    </Modal.Footer>
                </Modal>

                <Modal 
                
                    show={showOK} 
                    onHide={handleCloseOK} 
                    dialogClassName="modal-10w">

                    <Modal.Header closeButton>
                    <Modal.Title>{t('thank_you.label')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body><img src="images/Accept-icon.png" alt="" className="w-10" /> {sentMsg}</Modal.Body>
                    <Modal.Footer>
                    <Button variant="primary" onClick={handleCloseOK}>
                        {t('close.label')}
                    </Button>
                    
                    </Modal.Footer>
                </Modal>

                
               
            </React.Fragment>
        );
    
}
export default PricingSection;